import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import {
    AttestationCard,
    AttestationCardFallback,
    AttestationControls,
    LitePlanNotification,
} from '~/components/Patient';
import {
    attestationSectionSort,
    attestationSort,
    enumValue,
    logError,
    useSubmissionUploads,
} from '~/util';

export interface AttestationsProps {
    patient: PatientType;
    setStatus: (page: string, status: number) => void;
    status: number;
    externalUpload?: ExternalAttachmentType | null;
    clearExternalUpload: () => void;
}
export function Attestations({
    patient,
    status,
    setStatus,
    externalUpload = null,
    clearExternalUpload,
}: AttestationsProps) {
    const [uploads, setUploads] = React.useState<MediaFileType[]>([]);
    const [loading, setLoading] = React.useState(false);
    const submission = useSubmissionUploads(
        patient,
        JSON.stringify(patient.submissions),
        enumValue(['gap', 'type', 'Risk Gap']) as number,
        setUploads,
        setLoading
    );

    return (
        <>
            <AttestationControls
                patient={patient}
                submission={submission}
                setLoading={setLoading}
                externalUpload={externalUpload}
                clearExternalUpload={clearExternalUpload}
                loading={loading}
                setStatus={setStatus}
                status={status}
                uploads={uploads}
            />
            <div className="patient-gaps-container">
                <LitePlanNotification show={patient?.metadata?.AttestationVisibility === false} />
                {Object.values(attestationSort(patient.risk_gaps, status)).map(
                    (section: { title: string; entries: RiskGapType[] }) => (
                        <div key={section.title}>
                            {section.title && <p className="mt-2 fw-bold">{section.title}</p>}
                            <div className="row">
                                {attestationSectionSort(section.entries, submission).map(
                                    (riskGap: RiskGapType) => (
                                        <ErrorBoundary
                                            FallbackComponent={AttestationCardFallback}
                                            onError={logError}
                                            key={`${riskGap.id}-${riskGap.status}`}
                                        >
                                            <AttestationCard
                                                riskGap={{ ...riskGap }}
                                                patientId={patient.id}
                                                patientGmpi={patient.gmpi}
                                                submission={submission}
                                                disabled={loading}
                                                className="col-12 col-md-6 col-lg-4"
                                            />
                                        </ErrorBoundary>
                                    )
                                )}
                            </div>
                        </div>
                    )
                )}
            </div>
        </>
    );
}
